import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCarussel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCarussel"><Path fillRule="evenodd" clipRule="evenodd" d="M6 5V3H18V5H22V19H18V21H6V19H2V5H6ZM6 7H4V17H6V7ZM18 17H20V7H18V17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCarussel;
